import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './NotFound.css';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="not-found-page">
      <div className="not-found-container">
        <div className="not-found-code">404</div>
        <h1 className="not-found-title">{t('notFound.title', 'Page not found')}</h1>
        <p className="not-found-message">
          {t('notFound.message', 'The page you are looking for does not exist or has been moved.')}
        </p>
        <Link to="/" className="btn btn-primary">
          {t('notFound.backHome', 'Back to Home')}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
